import {minmax, sectionToFixedMap, portrait} from '../shared.js';
import {buildNarrativeTextTimeline, drawFrame, createFlipbook, scrubFlipbook} from '../animations.js';

const article = document.querySelector('#chapter11');

const narrativeSection = article.querySelector('#chapter11-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeTimeline = new TimelineLite({paused: true});

const narrativeText = narrativeFixed.querySelector('.narrative-text');
const kenBurns = narrativeFixed.querySelector('.ken-burns-effect');

const afghanistanSection = article.querySelector('#chapter11-flipbook-afghanistan');
const afghanistanFixed = sectionToFixedMap.get(afghanistanSection);
const afghanistanFlipbook = afghanistanFixed.querySelector('.flipbook');
const afghanistanFigure = afghanistanFixed.querySelector('figure');
const afghanistanTimeline = new TimelineLite({paused: true});
const afghanistanFootnote = afghanistanFixed.querySelector('.footnote');

const toraBoraSection = article.querySelector('#chapter11-flipbook-torabora');
const toraBoraFixed = sectionToFixedMap.get(toraBoraSection);
const toraBoraFlipbook = toraBoraFixed.querySelector('.flipbook');
const toraBoraHed = toraBoraFixed.querySelector('h1');
const toraBoraList = toraBoraFixed.querySelector('ol');
const toraBoraListItems = Array.from(toraBoraList.querySelectorAll('li'));
const toraBoraTimeline = new TimelineLite({paused: true});
const toraBoraFootnote = toraBoraFixed.querySelector('.footnote');

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter11:init');

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  TweenLite.set(kenBurns, {
    scale: 1,
    x: '0%',
    y: '0%',
  });
  narrativeTimeline.to(kenBurns, narrativeTimeline.duration(), {
    scale: 1.5,
    x: '+=10%',
    y: '+=15%',
    ease: Sine.easeOut,
  }, 0);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initAfghanistan();
  initToraBora();
}

/**
 * Setup infographic 1
 */
function initAfghanistan() {
  const afghanistanStart = 125;
  const afghanistanEnd = 425;
  const hidden = afghanistanFigure.querySelectorAll('dt:nth-of-type(n + 2)');

  TweenLite.set([afghanistanFigure, afghanistanFootnote], {opacity: 0});
  for (const hide of hidden) {
    TweenLite.set([hide, hide.nextElementSibling], {opacity: 0});
  }

  afghanistanSection.addEventListener('intersection', () => {
    const create = () => createFlipbook(afghanistanFlipbook, +article.dataset.chapter);
    portrait.addListener(create);
    create();
  }, {once: true});

  afghanistanTimeline.to({}, 100, {});

  afghanistanTimeline.to([afghanistanFootnote, afghanistanFigure], 25, {opacity: 1}, 150);

  afghanistanTimeline.to({}, 25, {});

  for (const hide of hidden) {
    afghanistanTimeline.to([hide, hide.nextElementSibling], 25, {opacity: 1}, '+=25');
  }

  afghanistanSection.addEventListener('scrub', ({detail: {vh}}) => {
    afghanistanTimeline.seek(minmax(0, vh, afghanistanTimeline.duration()), false);

    let percent = (vh < afghanistanStart) ? 0 : (vh > afghanistanEnd) ? 1 : (vh - afghanistanStart) / (afghanistanEnd - afghanistanStart);
    scrubFlipbook(afghanistanFlipbook, percent);
  });
}

/**
 * Setup infographic 2
 */
function initToraBora() {
  const toraBoraStart = 200;
  const toraBoraEnd = 600;

  TweenLite.set([toraBoraHed, ...toraBoraListItems, toraBoraFlipbook, toraBoraFootnote], {opacity: 0});
  TweenLite.set(toraBoraList, {visibility: 'hidden'});

  toraBoraSection.addEventListener('intersection', () => {
    const create = () => createFlipbook(toraBoraFlipbook, +article.dataset.chapter);
    portrait.addListener(create);
    create();
  }, {once: true});

  toraBoraTimeline.to({}, 125, {});

  toraBoraTimeline.to(toraBoraHed, 25, {opacity: 1});

  toraBoraTimeline.set(toraBoraList, {visibility: 'visible'}, toraBoraStart);

  toraBoraTimeline.to([toraBoraFootnote, toraBoraFlipbook], 25, {opacity: 1}, '-=25');

  toraBoraTimeline.set(toraBoraHed, {opacity: 0});

  for (const item of toraBoraListItems) {
    toraBoraTimeline.to(item, 25, {opacity: 1}, '+=50');
  }

  toraBoraSection.addEventListener('scrub', ({detail: {vh}}) => {
    toraBoraTimeline.seek(minmax(0, vh, toraBoraTimeline.duration()), false);

    let percent = (vh < toraBoraStart) ? 0 : (vh > toraBoraEnd) ? 1 : (vh - toraBoraStart) / (toraBoraEnd - toraBoraStart);
    scrubFlipbook(toraBoraFlipbook, percent);
  });
}
